import { useEffect } from "react"
import { useDispatch } from "react-redux";
import { updateHeader } from "../../slices/header-slice";
import { useLocation } from "react-router-dom";
import Animate from '../../components/animate';
import ContactForm from '../../components/contact-form';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './styles.scss';

const Contact = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const product = location?.state?.product;
    const finish = location?.state?.finish;
    const wishlist = location?.state?.wishlist;

    useEffect(() => {
        dispatch(updateHeader('dark'))
    }, [dispatch]);

    return (
        <>
            <div className="contact">

                <Animate>
                    <div className="text-section dark">
                        <h1>Contact us</h1>
                        <p>We hope you enjoyed viewing our work as much as we did making it. If you have a specific request or project idea, please don't hesitate to contact us directly through our contact form below.</p>
                    </div>
                </Animate>

                <Animate>
                    <ContactForm product={product} finish={finish} wishlist={wishlist} />
                </Animate>

            </div>
        </>

    )
}

export default Contact